import { Box } from "@mui/material";
import React from "react";
import classess from "./Style.module.css";
import Footer from "./Footer";

const Bücher = () => {
  const Title = " جدول مرتبط:";
  const FOOTER1 = {
    Title: "تحلیل گرامری جمله:",
    Type: "Nominativ",
    Examples: {
      1: ["Dieses Buch ist für Anfänger.", "این کتاب برای مبتدیان است"],
    },
  };
  const SubTitle1 = ["Plural", "Feminin", "Neutrum", "Maskulin", "Artikel"];
  const SubTitle2 = ["(die)", "(die)", "(das)", "(der)", ""];
  const ST1 = ["diese", "diese", "dieses", "dieser", "Nominativ"];
  const ST2 = ["diese", "diese", "dieses", "diesen", "Akkusativ"];

  return (
    <Box className={classess.Bücher}>
      <Footer FOOTER={FOOTER1} />
      <span>{Title}</span>
      <Box className={classess.WP}>
        {SubTitle1.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: `${330 / SubTitle1.length - 3}px`,
                backgroundColor: "rgba(150, 150, 150, 0.2)",
                fontSize: "1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {SubTitle2.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB2}
              sx={{
                width: `${330 / SubTitle2.length - 3}px`,
                backgroundColor: "rgba(190, 190, 190, 0.1)",
                fontSize: "1rem",
                lineHeight: "13px",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST1.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: `${330 / SubTitle2.length - 3}px`,
                fontSize: "1rem",
                backgroundColor: index === 1 ? "rgba(255,254,51,0.4)" : null,
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST2.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: `${330 / SubTitle2.length - 3}px`,
                fontSize: "1rem",
                backgroundColor: index === 1 ? "rgba(255,254,51,0.4)" : null,
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box sx={{ marginTop: "25px" }}>
        {" "}
        „für Anfänger“ (عبارت متممی - Präpositionalphrase)
      </Box>
      <Box>✔ für → حرف اضافه (Präposition) که همواره Akkusativ می‌گیرد.</Box>
      <Box>
        ✔ Anfänger → اسم در حالت Akkusativ، ولی تغییری نکرده چون جمع است.
      </Box>
      <Box>
        🔹 „für“ همیشه با Akkusativ استفاده می‌شود، اما چون „Anfänger“ در اینجا
        جمع بدون حرف تعریف است، تغییری در شکل آن دیده نمی‌شود.
      </Box>
    </Box>
  );
};

export default Bücher;
